import {IPermission} from '../Client/IPermission'

export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS';
export const GET_USER_PERMISSIONS_SUCCESS = 'GET_USER_PERMISSIONS_SUCCESS';
export const GET_USER_PERMISSIONS_FAILURE = 'GET_USER_PERMISSIONS_FAILURE';

export const UPDATE_PERMISSIONS         = 'UPDATE_PERMISSIONS';
export const UPDATE_PERMISSIONS_SUCCESS = 'UPDATE_PERMISSIONS_SUCCESS';
export const UPDATE_PERMISSIONS_FAILURE = 'UPDATE_PERMISSIONS_FAILURE';

interface GetUserPermissionsAction {
    type: typeof GET_USER_PERMISSIONS
}

interface GetUserPermissionsSuccessAction {
    type: typeof GET_USER_PERMISSIONS_SUCCESS,
    payload: {
        userPermissions: IPermission[]
    }
}

interface GetUserPermissionsFailureAction {
    type: typeof GET_USER_PERMISSIONS_FAILURE
}

interface UpdatePermissionsAction {
    type: typeof UPDATE_PERMISSIONS
    payload: {
        permissions: IPermission[]
    }
}

interface UpdatePermissionsSuccessAction {
    type: typeof UPDATE_PERMISSIONS_SUCCESS
}

interface UpdatePermissionsFailureAction {
    type: typeof UPDATE_PERMISSIONS_FAILURE
}

export type ActionTypes = GetUserPermissionsAction | GetUserPermissionsSuccessAction | GetUserPermissionsFailureAction
    | UpdatePermissionsAction | UpdatePermissionsSuccessAction | UpdatePermissionsFailureAction
